import { useMemo } from 'react';
import type { Campaign } from 'src/common/interfaces/campaigns';
import { useGetUserQuery } from 'src/common/slices';

export const useSubscribeNowCtaLink = (campaign: Campaign | null) => {
  const userQuery = useGetUserQuery();

  const user = userQuery.data?.data?.user;
  const isAnonymous = Boolean(!user);
  const isPremium = user?.isPremium;

  return useMemo(() => {
    const toUrl = (base: string) => {
      const utm = campaign?.utmCampaign;
      const url = new URL(base, window.location.origin);
      if (utm) url.searchParams.set('source', utm);
      return `${url.pathname}${url.search}`;
    };

    if (isAnonymous) return toUrl('/pricing');
    if (isPremium) return toUrl('/manage-account/subscription');
    return toUrl('/why-subscribe');
  }, [campaign?.utmCampaign, isAnonymous, isPremium]);
};
